import styled from "styled-components";

export const StyledRecoveryReviewPasswordStep = styled.div`
	max-width: 63rem;
	margin-top: 4rem;
`;